import { memo, useEffect } from "react";
import { useAtom } from 'jotai';
import { planetItemsLEFTAtom, planetItemsRIGHTAtom } from "./store";
import { getPlanetTileUrlTemplate } from "~/common/typescript/apis/PlanetAPIs";

const PlanetMapController = () => {
  const [planetItemsLeft] = useAtom(planetItemsLEFTAtom);
  const [planetItemsRight] = useAtom(planetItemsRIGHTAtom);

  // Get token for authenticated tile requests
  const getAuthToken = (): string | null => {
    return localStorage.jwt || null;
  };

  // Setup transformRequest for the map to add Authorization header
  const setupTransformRequest = (map: maplibregl.Map | undefined) => {
    if (!map) return;

    const token = getAuthToken();
    console.log('PlanetMapController - token:', token);

    map.setTransformRequest((url: string, resourceType: maplibregl.ResourceType | undefined) => {
      // Only add auth header for planet tile requests
      if (resourceType === 'Tile' && url.includes('/satellite/planet/')) {
        return {
          url,
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        };
      }
      return { url };
    });
  };

  // Helper to sync layers
  const syncLayers = (map: maplibregl.Map | undefined, items: any[]) => {
    if (!map) return;

    // Setup transformRequest for authenticated tile requests
    setupTransformRequest(map);

    // 1. Remove layers not in list
    const style = map.getStyle();
    if (style && style.layers) {
      style.layers.forEach(l => {
        if (l.id.startsWith('planet-layer-')) {
          const id = l.id.replace('planet-layer-', '');
          if (!items.find(i => i.id === id)) {
            map.removeLayer(l.id);
            if (map.getSource(l.id)) {
              map.removeSource(l.id);
            }
          }
        }
      });
    }

    // 2. Add layers in list
    items.forEach(item => {
      const layerId = `planet-layer-${item.id}`;
      const tileUrlTemplate = getPlanetTileUrlTemplate(item.url);

      if (!map.getLayer(layerId)) {
        const beforeId = map.getLayer('River labels') ? 'River labels' : undefined;

        map.addLayer({
          id: layerId,
          type: 'raster',
          source: {
            type: 'raster',
            tiles: [tileUrlTemplate],
            tileSize: 256,
          },
          paint: {
            'raster-opacity': 1
          }
        }, beforeId);
      }
    });
  };

  useEffect(() => {
    syncLayers(window.beforeMap, planetItemsLeft);
  }, [planetItemsLeft]);

  useEffect(() => {
    syncLayers(window.map, planetItemsRight);
  }, [planetItemsRight]);

  return <></>;
}

export default memo(PlanetMapController);
